import React from 'react';
import ContactHeroEn from '../components/ContactHeroEn';
import ContactEn from '../components/ContactEn';

function ContactPageEn() {
  return (
    <div className="page">
      <ContactHeroEn />
      <ContactEn />
    </div>
  );
}

export default ContactPageEn;
